import {ID_DELIMITER} from './ID_DELIMITER';

export const buildSortableItemId = (
  remoteId: string,
  containerId: string,
  url: string,
  position: number
) => ['sortable', remoteId, containerId, url, position].join(ID_DELIMITER);
